import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this.element.addEventListener("turbo:submit-start", this.startTransition.bind(this))
  }

  startTransition(event) {
    if (document.startViewTransition) {
      document.startViewTransition()
    }
  }
}
